import { createRoutine } from 'redux-saga-routines';

export const stakeTokenRoutine = createRoutine('boid/STAKE_TOKEN');
export const unstakeTokenRoutine = createRoutine('boid/UNSTAKE_TOKEN');
export const claimTokenRoutine = createRoutine('boid/CLAIM_TOKEN');
export const getTokenDataRoutine = createRoutine('boid/TOKEN_DATA');